import HomepageTakover from '@propertypal/web-ui/src/products/HomepageTakeover';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Developers Homepage Takeover - PropertyPal',
  description: 'Showcase Your Development On Our Homepage.',
  url: `/products/developers/homepage-takeover`,
};

const DeveloperHomepageTakeover = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <HomepageTakover dev />
      <ProductsContact reason="Developers Homepage Takeover" />
    </>
  );
};

export default DeveloperHomepageTakeover;
